/* assets/mxdvs-ascii-load.js (B3, 08.10.2026). Loaded by sections/mxdvs-product.liquid on desktop and phone.
   The EXACT effect of the /collections page (assets/mxdvs-collections-list.js: RAMP, GLYPHS, sample(), ascii()):
   the photo is typed out line by line in characters with a band of scrambled glyphs, held for a moment,
   then the canvas fades away and the real photo shows. The photo loads normally underneath (no delay to LCP).
   prefers-reduced-motion: no effect. */
(function () {
  'use strict';
  var GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%/<>';
  var RAMP = '@%#*+=-:. ';
  function cfg(k, d) { var C = window.MXDVS_ASCII_LOAD || {}; return typeof C[k] === 'undefined' ? d : C[k]; }

  /* Brightness grid of the photo, from a small copy */
  function sample(url, cols, rows) {
    return new Promise(function (resolve) {
      if (!url) { resolve(null); return; }
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var c = document.createElement('canvas');
          c.width = cols; c.height = rows;
          var x = c.getContext('2d');
          /* cover crop, like the photo in the slide */
          var ir = im.width / im.height, cr = cols / (rows * 1.62);
          var sw = im.width, sh = im.height, sx = 0, sy = 0;
          if (ir > cr) { sw = im.height * cr; sx = (im.width - sw) / 2; } else { sh = im.width / cr; sy = (im.height - sh) / 2; }
          x.fillStyle = '#fff'; x.fillRect(0, 0, cols, rows);
          x.drawImage(im, sx, sy, sw, sh, 0, 0, cols, rows);
          var d = x.getImageData(0, 0, cols, rows).data, out = [];
          for (var i = 0; i < cols * rows; i++) {
            var l = (0.299 * d[i * 4] + 0.587 * d[i * 4 + 1] + 0.114 * d[i * 4 + 2]) / 255;
            out.push(RAMP[Math.min(RAMP.length - 1, Math.floor(l * RAMP.length))]);
          }
          c.width = c.height = 0;
          resolve(out);
        } catch (e) { resolve(null); }
      };
      im.onerror = function () { resolve(null); };
      im.src = url;
    });
  }

  function loaded(img) { return img.decode ? img.decode().catch(function () {}) : Promise.resolve(); }

  function run(slide) {
    if (!slide || slide._mxa || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var img = slide.querySelector('img');
    if (!img) return;
    slide._mxa = true;
    if (getComputedStyle(slide).position === 'static') slide.style.position = 'relative';
    var fade = cfg('fade', 900);
    if (!document.getElementById('mxa-css')) {
      var st = document.createElement('style'); st.id = 'mxa-css';
      st.textContent = '.mxa{position:absolute;inset:0;width:100%;height:100%;z-index:3;pointer-events:none;transition:opacity ' + fade + 'ms ease}.mxa.is-out{opacity:0}';
      document.head.appendChild(st);
    }
    var cv = document.createElement('canvas');
    cv.className = 'mxa'; cv.setAttribute('aria-hidden', 'true');
    slide.appendChild(cv);
    var desk = window.matchMedia('(min-width: 990px)').matches;
    var ch = Math.max(5, desk ? cfg('cell', 10) : cfg('cellM', 7));
    var W = slide.clientWidth, H = slide.clientHeight, dpr = Math.min(2, window.devicePixelRatio || 1);
    var cw = ch * 0.62, cols = Math.ceil(W / cw), rows = Math.ceil(H / ch);
    var ink = cfg('ink', '#000'), bg = cfg('bg', '#f2f2f2');
    var typeMs = cfg('typeMs', 1100), band = Math.max(1, cfg('band', 5)), hold = cfg('hold', 500);

    sample(img.getAttribute('data-ascii') || img.currentSrc || img.src, cols, rows).then(function (grid) {
      if (!grid) { grid = []; for (var i = 0; i < cols * rows; i++) grid.push(RAMP[Math.floor(Math.random() * RAMP.length)]); }
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      var x = cv.getContext('2d');
      x.scale(dpr, dpr);
      x.font = '400 ' + ch + 'px "Roboto Mono", ui-monospace, Menlo, Consolas, monospace';
      x.textBaseline = 'top';
      x.fillStyle = bg; x.fillRect(0, 0, W, H);
      function row(r, scrambled) {
        x.fillStyle = bg; x.fillRect(0, r * ch, W, ch);
        x.fillStyle = ink;
        for (var c = 0; c < cols; c++) {
          var g = grid[r * cols + c];
          if (g === ' ') continue;
          if (scrambled) g = GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
          x.fillText(g, c * cw, r * ch);
        }
      }
      var settled = 0, t0 = performance.now();
      (function step(now) {
        var k = Math.min(1, (now - t0) / typeMs), head = Math.floor(k * (rows + band));
        while (settled < rows && settled < head - band) row(settled++, false);
        for (var r = Math.max(settled, head - band); r < Math.min(rows, head); r++) row(r, true);
        if (settled < rows) { requestAnimationFrame(step); return; }
        /* Hold as ASCII, then develop into the photo once it has loaded */
        Promise.all([loaded(img), new Promise(function (res) { setTimeout(res, hold); })]).then(function () {
          cv.classList.add('is-out');
          setTimeout(function () { if (cv.parentNode) cv.parentNode.removeChild(cv); }, fade + 60);
        });
      })(t0);
    });
  }

  window.mxAsciiLoad = run;
  /* The product page builds its photos with a script: wait for the first photo of the page (once per page load) */
  var fired = false, tries = 0;
  function boot() {
    if (fired) return;
    var first = document.querySelector('.pp-stack .pp-slide, .pp-track .pp-slide');
    if (first && first.querySelector('img') && first.clientHeight > 50) { fired = true; run(first); return; }
    if (++tries < 80) setTimeout(boot, 100);
  }
  boot();
})();
